<template>
  <div
    class="mt-5"
    style="display: grid; justify-content: center; touch-action: none"
  >
    <!-- init camera -->
    <div v-if="!isCameraOpen && !isCapture" class="alert alert-info">
      Camera init...
      <i class="fa fa-spinner fa-pulse"></i>
    </div>
    <!-- camerastream -->
    <video
      v-show="isCameraOpen"
      ref="camera"
      :width="cW"
      :height="cH"
      autoplay
      style="transform: scaleX(-1)"
    ></video>

    <!-- edit picture -->
    <div v-show="isCapture" style="position: relative">
      <div
        id="wrapper"
        :style="{ width: cW + 'px', height: cH + 'px' }"
        @mousewheel="mouseWheel"
        @contextmenu="($event) => $event.preventDefault()"
      >
        <canvas
          v-show="isCapture"
          id="canvas"
          ref="canvas"
          :width="cW"
          :height="cH"
        >
        </canvas>
        <div id="move"></div>
      </div>

      <div id="zoomL">
        (x: {{ Math.round(pos.ix) }}, y: {{ Math.round(pos.iy) }})
      </div>
      <div id="zoomR">Zoom: {{ Math.round(scale * 100) }} %</div>
    </div>

    <hr class="mt-5 mb-3" />

    <div v-if="isCameraOpen" class="d-flex justify-space-between">
      <v-btn text color="secondary" @click="$emit('close')">
        Aufnahme abbrechen
      </v-btn>

      <v-btn text color="success" @click="captureImage()">
        Photo aufnehmen
      </v-btn>
    </div>
    <div v-if="isCapture" style="display: flex; justify-content: space-between">
      <v-btn text color="primary" class="mr-3" @click="reloadImage()">
        {{ cameraFile == '' ? 'Aufnahme wiederholen' : 'Abbrechen' }}
      </v-btn>

      <v-btn text color="success" @click="getImage()"> Bild übernehmen </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: ['cameraFile'],
  data() {
    return {
      isCameraOpen: false,
      isCapture: false,
      cH: 500,
      cW: 500,
      //---
      image: new Image(),
      canvas: '',
      ctx: '',
      scale: 1, // current scale
      pos: { sx: 0, sy: 0, mx: 0, my: 0, ix: 0, iy: 0 }, // start, mouse, image position
      touchCache: [],
      prevDiff: -1,
    }
  },
  created() {
    window.addEventListener('resize', this.resizeCanvas)
  },
  mounted() {
    if (this.cameraFile == '') this.startCameraStream()
    else this.setImage()

    let el = document.getElementById('wrapper')

    el.addEventListener('pointerdown', this.pointerDown, true)
    el.addEventListener('pointermove', this.pointerMove, true)
    el.addEventListener('pointerup', this.pointerUp, true)
  },
  computed: {},
  methods: {
    startCameraStream() {
      this.isCapture = false

      navigator.mediaDevices
        .getUserMedia({ audio: false, video: true })
        .then((stream) => {
          this.isCameraOpen = true
          let video = this.$refs.camera
          video.srcObject = stream
          video.onloadedmetadata = (e) => {
            this.cW = e.target.videoWidth
            this.cH = e.target.videoHeight
            // video.play()
            this.resizeCanvas()
          }
        })
        .catch((error) => {
          alert("Browser doesn't support or there is some errors. " + error)
        })
    },
    reloadImage() {
      if (this.cameraFile == '') this.startCameraStream()
      else this.$emit('close')
    },
    stopCameraStream() {
      this.$refs.camera.srcObject.getTracks().forEach((track) => {
        if (track.readyState == 'live' && track.kind === 'video') {
          track.stop()
        }
      })
      this.isCameraOpen = false
    },
    setImage() {
      this.canvas = this.$refs.canvas
      this.ctx = this.canvas.getContext('2d')
      this.isCapture = true

      this.initPicture(this.cameraFile).then(() => {
        var X = Math.abs(
          document.getElementById('editAvatarWindow').clientWidth /
            this.image.width
        )
        var Y = Math.abs((window.innerHeight - 350) / this.image.height)
        var factor = X < Y ? X : Y

        this.cW = this.image.width * factor
        this.cH = this.image.height * factor
        this.image.onload = () => {
          this.drawCanvas()
        }
      })
    },
    initPicture(file) {
      return new Promise((resolve) => {
        var reader = new FileReader()
        reader.onload = () => {
          var output = this.image
          output.src = reader.result
          resolve(true)
        }
        reader.readAsDataURL(file)
      })
    },
    captureImage() {
      this.canvas = this.$refs.canvas
      this.ctx = this.canvas.getContext('2d')
      //reset
      this.ctx.setTransform(1, 0, 0, 1, 0, 0)
      this.scale = 1
      this.pos = { sx: 0, sy: 0, mx: 0, my: 0, ix: 0, iy: 0 }

      // camerabild spiegeln
      this.ctx.setTransform(-1, 0, 0, 1, this.cW, 0)
      // videostream clip to canvas
      this.ctx.drawImage(this.$refs.camera, 0, 0, this.cW, this.cH)
      this.image.src = this.$refs.canvas.toDataURL()

      this.isCameraOpen = false
      this.isCapture = true
      this.stopCameraStream()
    },
    pointerDown(e) {
      var offset = this.getRelativeCoordinates(e, this.$refs.canvas)

      this.touchCache.push(e)
      this.pos.sx = offset.x
      this.pos.sy = offset.y
    },
    pointerMove(e) {
      if (this.touchCache.length > 0) {
        for (let i = 0; i < this.touchCache.length; i++) {
          if (this.touchCache[i].pointerId == e.pointerId) {
            this.touchCache[i] = e
            break
          }
        }

        if (this.touchCache.length == 2) {
          this.mouseWheel()
        } else {
          // mouseMove
          var offset = this.getRelativeCoordinates(e, this.$refs.canvas)
          this.pos.ix = offset.x - this.pos.sx + this.pos.mx
          this.pos.iy = offset.y - this.pos.sy + this.pos.my
          this.drawCanvas()
        }
      }
    },
    pointerUp(e) {
      for (let i = 0; i < this.touchCache.length; i++) {
        if (this.touchCache[i].pointerId == e.pointerId) {
          this.touchCache.splice(i, 1)
        }
      }

      this.pos.mx = this.pos.ix
      this.pos.my = this.pos.iy

      if (this.touchCache.length < 2) this.prevDiff = -1
    },
    mouseWheel(event) {
      var offset = { x: 0, y: 0 }
      var zoom = 1

      if (event == undefined) {
        var curDiff = Math.abs(
          this.touchCache[0].clientX - this.touchCache[1].clientX
        )

        if (this.prevDiff > 0) {
          if (curDiff > this.prevDiff) {
            zoom = 1.01
          }
          if (curDiff < this.prevDiff) {
            zoom = 1 / 1.01
          }
        }

        // cache the distance for the next move event
        this.prevDiff = curDiff

        var off0 = this.getRelativeCoordinates(
          this.touchCache[0],
          this.$refs.canvas
        )
        var off1 = this.getRelativeCoordinates(
          this.touchCache[1],
          this.$refs.canvas
        )
        var x = Math.abs(off0.x / 2 + off1.x / 2)
        var y = Math.abs(off0.y / 2 + off1.y / 2)
        offset.x = x
        offset.y = y
      } else {
        offset = this.getRelativeCoordinates(event, this.$refs.canvas)
        zoom = event.deltaY < 0 ? 1.1 : 1 / 1.1
        event.preventDefault()
      }

      this.scale *= zoom
      this.pos.mx = this.pos.ix = Math.round(
        offset.x - (offset.x - this.pos.ix) * zoom
      )
      this.pos.my = this.pos.iy = Math.round(
        offset.y - (offset.y - this.pos.iy) * zoom
      )
      this.drawCanvas()
    },
    drawCanvas() {
      this.ctx.setTransform(1, 0, 0, 1, 0, 0)
      this.ctx.clearRect(0, 0, this.cW, this.cH)
      this.ctx.transform(this.scale, 0, 0, this.scale, this.pos.ix, this.pos.iy)
      this.ctx.drawImage(this.image, 0, 0, this.cW, this.cH)
    },
    getImage() {
      const canvas = document.createElement('canvas')
      const start = { x: this.cW / 2 - 130, y: this.cH / 2 - 130 }
      const imgData = this.ctx.getImageData(start.x, start.y, 260, 260)

      canvas.width = 260
      canvas.height = 260
      canvas.getContext('2d').putImageData(imgData, 0, 0)
      this.$emit('setImage', canvas.toDataURL())
    },
    // helper functions
    resizeCanvas() {
      let maxX = document.getElementById('editAvatarWindow').clientWidth

      this.cH = (maxX / this.cW) * this.cH
      this.cW = maxX

      if (this.isCapture) this.drawCanvas()
    },
    getRelativeCoordinates(event, referenceElement) {
      const position = {
        x: event.pageX,
        y: event.pageY,
      }

      const offset = {
        left: referenceElement.offsetLeft,
        top: referenceElement.offsetTop,
      }

      let reference = referenceElement.offsetParent

      while (reference) {
        offset.left += reference.offsetLeft
        offset.top += reference.offsetTop
        reference = reference.offsetParent
      }

      return {
        x: position.x - offset.left,
        y: position.y - offset.top,
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeCanvas)
    if (this.isCameraOpen) this.stopCameraStream()
  },
  components: {},
}
</script>

<style scoped>
canvas:hover {
  cursor: move;
}

#wrapper {
  width: 300px;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

#wrapper:hover {
  cursor: move;
}

#canvas {
  position: absolute;
}

#move {
  width: 260px;
  height: 260px;
  border: 1px solid #ccc;
  border-radius: 50%;
  box-shadow: rgb(180 180 180 / 50%) 0px 0px 0px 5000px;
  z-index: 0;
}

#zoomL {
  position: absolute;
  bottom: 1px;
  left: 5px;
  color: #fff;
  font-size: 80%;
}

#zoomR {
  position: absolute;
  bottom: 1px;
  right: 5px;
}
</style>
